export default __webpack_public_path__ + "static/media/helm_of_vengeful_zeal.c5f4c00d.jpg";